export default __webpack_public_path__ + "static/black-grey-desserto-1fe9847040a08cc29612264d8231debd.jpg";